(() => {
  if (window.HouseIXPersonalization) return;
  const houses = ['vanta', 'ember', 'aether', 'tide'];
  const storageKey = 'houseix-chosen-house';
  const completed = () => {
    try { return localStorage.getItem('houseix-discovery-complete-v1') === 'true'; }
    catch { return Boolean(window.HouseIXDiscovery?.isComplete?.()); }
  };
  let choice = null;
  let previousFocus = null;
  try {
    const stored = localStorage.getItem(storageKey);
    if (houses.includes(stored) || stored === 'all') choice = stored;
  } catch {}
  const picker = () => document.querySelector('[data-hix-house-picker]');
  const houseAt = path => path.match(/(?:^|\/)(?:pages|collections)\/house-of-(vanta|ember|aether|tide)(?:\/|$)/)?.[1] || null;
  const proper = house => house.charAt(0).toUpperCase() + house.slice(1);
  const format = (text, house) => (text || '').replace('__HOUSE__', proper(house));
  const apply = () => {
    const house = houses.includes(choice) ? choice : null;
    if (house) document.documentElement.dataset.hixHouse = house;
    else delete document.documentElement.dataset.hixHouse;
    const labels = picker()?.dataset;
    document.querySelectorAll('[data-hix-house-current]').forEach(node => {
      node.textContent = house ? proper(house) : labels?.allLabel || node.textContent;
    });
    document.querySelectorAll('[data-hix-house-open]').forEach(node => {
      const text = house ? node.dataset.changeLabel : node.dataset.chooseLabel;
      const textNode = [...node.childNodes].find(child => child.nodeType === 3);
      if (textNode) textNode.textContent = text + ' ';
    });
    document.querySelectorAll('[data-hix-house-choice]').forEach(node => {
      const current = node.dataset.hixHouseChoice === house;
      if (current) node.setAttribute('aria-current', 'true');
      else node.removeAttribute('aria-current');
      const badge = node.querySelector('[data-hix-house-picked]');
      if (badge) badge.hidden = !current;
    });
    document.querySelectorAll('.hix-ambient').forEach(node => {
      houses.forEach(name => node.classList.remove('hix-ambient--' + name));
      const atmosphere = house || houseAt(window.location.pathname);
      if (atmosphere) node.classList.add('hix-ambient--' + atmosphere);
    });
    document.querySelectorAll('[data-hix-elements][data-collective=true]').forEach(stage => {
      if (!labels) return;
      const heading = stage.querySelector('h1');
      const copy = stage.querySelector('.hix-world__copy');
      const eyebrow = stage.querySelector('.hix-world__eyebrow');
      const primary = stage.querySelector('.hix-world__link:not(.hix-world__link--quiet):not(.hix-world__link--film)');
      [heading, copy, eyebrow].forEach(node => {
        if (node && node.dataset.hixDefaultText === undefined) node.dataset.hixDefaultText = node.textContent;
      });
      if (primary && primary.dataset.hixDefaultHref === undefined) {
        primary.dataset.hixDefaultHref = primary.getAttribute('href');
        const textNode = [...primary.childNodes].find(child => child.nodeType === 3);
        primary.dataset.hixDefaultText = textNode?.textContent || '';
      }
      if (heading) heading.textContent = house ? format(labels.welcomeLabel, house) : heading.dataset.hixDefaultText;
      if (copy) copy.textContent = house ? labels[house + 'Copy'] : copy.dataset.hixDefaultText;
      if (eyebrow) eyebrow.textContent = house ? 'HOUSE IX / ' + house.toUpperCase() : eyebrow.dataset.hixDefaultText;
      if (primary) {
        const textNode = [...primary.childNodes].find(child => child.nodeType === 3);
        if (textNode) textNode.textContent = house ? format(labels.shopLabel, house) + ' ' : primary.dataset.hixDefaultText;
        primary.setAttribute('href', house ? '/collections/house-of-' + house : primary.dataset.hixDefaultHref);
      }
      stage.querySelectorAll('.hix-world__houses a').forEach(link => {
        if (house && houseAt(new URL(link.href).pathname) === house) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      const slides = [...stage.querySelectorAll('[data-element-slide]')];
      if (house) {
        stage.dataset.house = house;
        slides.forEach(slide => {
          const active = slide.dataset.elementSlide === house;
          slide.classList.toggle('is-active', active);
          const image = slide.querySelector('img');
          if (active && image) { image.loading = 'eager'; image.fetchPriority = 'high'; }
        });
      } else if (slides.length) {
        // Restore the collective view when a visitor returns to Main Page.
        stage.dataset.house = slides[0].dataset.elementSlide;
        slides.forEach((slide, index) => slide.classList.toggle('is-active', index === 0));
      }
    });
  };
  const select = (house, persist = true) => {
    if (!houses.includes(house) && house !== 'all') return;
    choice = house;
    if (persist) {
      try { localStorage.setItem(storageKey, house); } catch {}
    }
    apply();
    const root = picker();
    const status = document.querySelector('[data-hix-house-status]');
    if (status && root) status.textContent = house === 'all' ? root.dataset.allLabel : format(root.dataset.selectedMessage, house);
    document.dispatchEvent(new CustomEvent('houseix:house:change', {detail: {house}}));
  };
  const restoreFocus = () => {
    document.documentElement.classList.remove('hix-house-picker-open');
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
    previousFocus = null;
  };
  const close = (dismissed = true, focus = true) => {
    if (!completed()) return;
    const root = picker();
    if (!focus) previousFocus = null;
    if (root?.open) root.close();
    restoreFocus();
    if (dismissed) {
      try { sessionStorage.setItem('houseix-house-prompt-dismissed', 'true'); } catch {}
    }
  };
  const open = trigger => {
    const root = picker();
    if (!root || root.open || typeof root.showModal !== 'function' || root.dataset.editor === 'true') return;
    const intro = document.querySelector('[data-hix-cutscene]');
    if (intro?.open) return;
    previousFocus = trigger || document.activeElement;
    apply();
    window.HouseIXDiscovery?.prepare?.();
    try { root.showModal(); } catch { previousFocus = null; return; }
    document.documentElement.classList.add('hix-house-picker-open');
    const target = root.querySelector('[data-hix-discovery-start]');
    target?.focus({preventScroll: true});
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const element = event.target.closest?.('[data-hix-house-open],[data-hix-house-close],[data-hix-house-choice],[data-hix-house-neutral],a[href]');
    if (!element) return;
    if (element.hasAttribute('data-hix-house-open')) {
      if (typeof picker()?.showModal !== 'function') return;
      event.preventDefault();
      open(element);
      return;
    }
    if (element.hasAttribute('data-hix-house-close')) {
      event.preventDefault();
      close();
      return;
    }
    if (element.hasAttribute('data-hix-house-choice') || element.hasAttribute('data-hix-house-neutral')) {
      const house = element.dataset.hixHouseChoice || 'all';
      select(house);
      close(false, false);
      const url = new URL(element.href, window.location.href);
      if (url.pathname === window.location.pathname) event.preventDefault();
      return;
    }
    if (element.tagName !== 'A' || element.hasAttribute('download') || (element.target && element.target !== '_self')) return;
    let url;
    try { url = new URL(element.href, window.location.href); } catch { return; }
    const house = url.origin === window.location.origin ? houseAt(url.pathname) : null;
    if (house && house !== choice) select(house);
  }, {capture: true});
  document.addEventListener('cancel', event => {
    if (!event.target.matches?.('[data-hix-house-picker]')) return;
    event.preventDefault();
    if (completed()) close();
  }, {capture: true});
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-hix-house-picker]')) restoreFocus();
  }, {capture: true});
  document.addEventListener('houseix:intro:complete', () => { if (!completed()) open(); });
  document.addEventListener('shopify:section:load', apply);
  window.addEventListener('pageshow', apply);
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    choice = houses.includes(event.newValue) || event.newValue === 'all' ? event.newValue : null;
    apply();
  });
  const ready = () => {
    apply();
    const root = picker();
    if (!completed() && root?.dataset.gate === 'true' && root.dataset.editor !== 'true' && !document.querySelector('[data-hix-cutscene]')?.open) open();
  };
  window.HouseIXPersonalization = {select, open, close, getHouse: () => choice};
  if (document.readyState === 'complete') ready();
  else document.addEventListener('DOMContentLoaded', ready, {once: true});
  apply();
})();
